export const APP_NAME = 'gig_page_perseus';
export const GIG_PAGE_CLIENT = {
    name: 'gig_page_client',
};

// Name of route key must be the same as the method calling it to avoid multiple route keys with the same name
export const ROUTE_KEYS = {
    GET_LOYALTY_POINTS: 'calculate_potential_loyalty_points',
    GET_SELLER_HOURLY_ELIGIBILITY: 'get_seller_hourly_eligibility',
    GET_GIG_PAGE_DATA_VIEW_VERIFIED: 'get_gig_page_data_view_verified',
    GET_PERSONAL_ASSISTANT_STATUS: 'fetch_personal_assistant_status',
    GIG_PAGE_INITIAL_DATA_DOCUMENT: 'gig_page_initial_data_document',
    GET_GIG_SELLER: 'seller_phoenix.fetch_seller_data',
    GET_REVIEWS: 'get_reviews',
} as const;
